import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  margin: 0 5%;
`

const StyledH2 = styled.h2`
  font-size: 1.4rem;
  font-weight: bold;
`

const StyledH3 = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
`

const StyledH4 = styled.h4`
  font-size: 1.1rem;
  font-weight: bold;
`

const StyledP = styled.p`
  font-size: 1rem;
`

const PrivateTermsAndConditions = () => (
  <Wrapper>
    <StyledH2>Code States 개인정보취급방침</StyledH2>
    <StyledP>
      Code States(이하 "서비스공급자"라 함)은 통신비밀보호법, 전기통신사업법,
      정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가
      준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에
      의거한 개인정보취급방침을 정하여 이용자 권익 보호에 최선을 다하고
      있습니다.
    </StyledP>
    <StyledH3>용어의 정의</StyledH3>
    <StyledP>
      이 개인정보취급방침에서 사용하는 용어의 정의는 다음과 같습니다.
      <br />
      ① "이용자"란 서비스공급자가 제공하는 모든 제반 서비스를 이용하는 고객을
      의미합니다.
      <br />
      ② "서비스"란 서비스공급자가 제공하는 모든 서비스 일체를 의미합니다.
      <br />
      ③ "단말기"란 서비스를 다운로드 받거나 설치하여 사용할 수 있는 PC, 휴대폰,
      스마트폰, PDA, 태블릿 등의 기기를 말합니다.
      <br />
      ④ "애플리케이션"이란 서비스공급자가 제공하는 서비스를 이용하기 위하여
      ‘③항’에서 설명한 단말기를 통해 다운로드 받거나 설치하여 사용하는 프로그램
      일체를 말합니다.
      <br />
      ⑤ "앱스토어(오픈마켓)사업자"란 당사 서비스를 설치하고 결제할 수 있도록
      제공하는 오픈마켓 등 전자상거래 제공자 일체(서비스 내 결제를 제공하는
      사업자 포함)를 제공하는 사업자를 말합니다. (예. 구글 플레이 앱스토어, 애플
      앱스토어, 티스토어, 올레마켓, 유플러스 앱마켓 등)
      <br />
      ⑥ "플랫폼사업자"란 당사 서비스를 알리거나 이용함에 있어서 서비스공급자와
      제휴하여 서비스를 제공하는 사업자 및 관련 서비스 일체를 말합니다. (예.
      (주)카카오 의 카카오톡, (주)라인 의 라인, Facebook Inc. 의 페이스북 등)
      <br />
      ⑦ "이용자 계정"이란 ‘⑥항’에서 설명한 플랫폼사업자가 제공하는 본인식별을
      위한 아이디, 메일주소 등의 정보로서 플랫폼사업자가 직접적으로 명기 및
      노출하여 제공받지 아니하고 고유식별번호(특별한 숫자 또는 문자로
      이루어짐)를 제공 받아 사용합니다. (예. TID, UID 등)
      <br />
      ⑧ "유료콘텐츠"라 함은, 이용자가 서비스를 이용함에 있어 특정한 효과 또는
      효능을 향유하기 위하여 ‘⑤항’에서 설명한 "앱스토어"를 통해 구매하는 온라인
      콘텐츠 일체를 의미합니다. (예. 코인, 캐쉬 등)
      <br />
      ⑨ "무료콘텐츠"라 함은, 이용자가 서비스 내에서 ‘⑧항’에서 유료콘텐츠를 통해
      구매하지 아니한 이용자 간 선물이나 서비스 서비스를 이용하면서 취득할 수
      있는 온라인 콘텐츠 일체를 의미합니다. (예. 포인트 등)
      <br />
      이 개인정보취급방침에서 사용하는 용어의 정의는 위 내용에서 정하는 것을
      제외하고는 관계법령에서 정하는 바에 의합니다. 관계법령에서 정하지 않는
      것은 일반적인 상관례에 의합니다.
      <br />
    </StyledP>
    <StyledH3>1. 수집하는 개인정보의 항목 및 수집방법</StyledH3>
    <StyledH4>가. 수집하는 개인정보의 항목</StyledH4>
    <StyledP>
      첫째, 서비스공급자는 서비스가입 시 각종 서비스의 제공을 위해 최초
      서비스가입 당시 아래와 같은 개인정보를 수집하고 있습니다.
      <br />
      이용자의 플랫폼사업자의 서비스에서 제공되는 고유식별번호, 이용자 이름 또는
      별명, 기기고유번호 (단말기 아이디 또는 IMEI) 등 둘째, 서비스 이용과정에서
      아래와 같은 정보들이 생성되어 저장 및 수집될 수 있습니다.
      <br />
      이용자 입력내용 및 상태정보, 방문 일시, 서비스 이용 기록, 불량 이용 기록
      등.
      <br />
      셋째, 무료/유료 서비스 이용 과정에서 결제 등을 위하여 불가피하게 필요한
      경우 신용카드 정보, 통신사 정보, 구매내역 및 상품권 번호, 기타 결제 관련
      정보가 수집될 수 있으며, 고객의 유료 콘텐츠 복구 및 환불을 요청할 시
      원활한 고객상담을 위하여 메일 주소 및 구매내역 확인내용, 그리고 본인이
      아닌 타인에 의해 결제된 사실확인을 위해 실명과 가족관계 증명 등 추가적인
      개인정보를 수집할 수 있습니다.
      <br />
    </StyledP>
    <StyledH4>나. 개인정보 수집방법</StyledH4>
    <StyledP>
      서비스공급자는 다음과 같은 방법으로 개인정보를 수집합니다.
      <br />
      당사와 서비스제공 관련 제휴관계에 있는 플랫폼을 통해 자동으로 수집, 또는
      서비스 가입이나 사용 중 이용자의 자발적 제공을 통한 수집
    </StyledP>
    <StyledH3>2. 개인정보의 수집 및 이용목적</StyledH3>
    <StyledH4>가. 서비스 기본 기능의 제공서비스</StyledH4>
    <StyledP>
      공급자는 이용자 계정의 고유식별번호를 통해 플랫폼사업자에게서 제공 받은
      이용자의 친구에게 초대하기, 선물하기, 추천하기, 순위보기 등의 서비스를
      제공합니다. 또한 이용자의 가입시에 기기고유번호 (단말기 아이디 또는 UDID,
      IMEI)를 수집하고 저장하여 이용자 계정의 정상 여부를 식별하는 데 사용할 수
      있습니다.
    </StyledP>
    <StyledH4>
      나. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
    </StyledH4>
    <StyledP>
      무료 또는 유료콘텐츠의 제공, 구매를 통한 물품배송 또는 청구서 등 발송,
      본인인증, 구매 및 요금 결제, 요금추심
    </StyledP>
    <StyledH4>다. 회원관리</StyledH4>
    <StyledP>
      회원제 서비스 이용에 따른 본인확인, 서비스서비스 제공과 관련한 이용자
      확인, 개인식별, 불량회원(Code States 서비스 이용약관 제6조 제1항 내지
      제13조 제1항, 제3,4,5,7,8,9호 해당 또는 위반 등으로 인하여 계약 해지된
      회원)의 부정 이용방지와 비인가 사용방지, 가입의사 확인, 가입 및 가입횟수
      제한, 본인확인 및 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리,
      고지사항 전달
    </StyledP>
    <StyledH4>라. 신규 서비스 개발 및 마케팅/광고에의 활용</StyledH4>
    <StyledP>
      신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및
      광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회
      제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계
    </StyledP>
    <StyledH3>3. 개인정보의 공유 및 제공</StyledH3>
    <StyledP>
      서비스공급자는 이용자들의 개인정보를 "개인정보의 수집목적 및 이용목적"에서
      고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여
      이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만,
      아래의 경우에는 주의를 기울여 개인정보를 이용 및 제공할 수 있습니다.
    </StyledP>
    <StyledH4>가. 이용자들이 사전에 제공에 동의한 경우: </StyledH4>
    <span>
      정보수집 또는 정보제공, 취급위탁 이전에 이용자에게 서비스공급자의
      제휴업체가 누구인지, 그리고 언제까지 어떻게 보호/관리되는지 알려드리고
      동의를 구하는 절차를 거치게 되며, 이용자가 동의하지 않는 경우에는 추가적인
      정보를 수집하거나 제휴 업체와 공유하지 않습니다. 이용자들의 동의를 얻어
      개인정보를 제공하는 경우, 그 제공받는 자와 이용목적 등은 아래와 같습니다.
    </span>
    <StyledH4>제공받는 자 및 이용목적</StyledH4>
    <StyledP>
      - 당사와 직접 제휴된 파트너사 등 최대 1년.
      <br />
      이용자가 1:1 상담을 요청한 경우 연락처 및 입력내용 등 정보를
      전자우편(이메일)으로 전송하여 취급.
      <br />
      취급기간(1년)이 만료된 경우 즉시 메일함에서 삭제
    </StyledP>
    <StyledH4>
      나. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에
      따라 수사기관의 요구가 있는 경우
    </StyledH4>
    <StyledH3>4. 개인정보의 취급위탁</StyledH3>
    <StyledP>
      서비스공급자는 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고
      있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록
      필요한 사항을 규정하고 있습니다.
      <br />
      <br />
      서비스공급자의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.
    </StyledP>
    <StyledH4>수탁받는 자 및 이용목적</StyledH4>
    <StyledP>없음</StyledP>
    <StyledH3>5. 개인정보의 보유 및 이용기간</StyledH3>
    <StyledP>
      이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체
      없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안
      보존합니다.
    </StyledP>
    <StyledH4>가. 서비스공급자 내부 방침에 의한 정보보유 사유</StyledH4>
    <StyledP>
      - 부정이용기록 (보존 이유 : 부정 이용 방지, 보존 기간 : 1년)
    </StyledP>
    <StyledH4>나. 관련법령에 의한 정보보유 사유</StyledH4>
    <StyledP>
      상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에
      의하여 보존할 필요가 있는 경우 서비스공급자는 관계법령에서 정한 일정한
      기간 동안 회원정보를 보관합니다. 이 경우 서비스공급자는 보관하는 정보를 그
      보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
      <br />
      - 계약 또는 청약철회 등에 관한 기록 (보존 이유 : 전자상거래 등에서의
      소비자보호에 관한 법률, 보존 기간 : 5년)
      <br />
      - 대금결제 및 재화 등의 공급에 관한 기록 (보존 이유 : 전자상거래 등에서의
      소비자보호에 관한 법률, 보존 기간 : 5년)
      <br />
      - 소비자의 불만 또는 분쟁처리에 관한 기록 (보존 이유 : 전자상거래 등에서의
      소비자보호에 관한 법률, 보존 기간 : 3년)
      <br />
      - 본인확인에 관한 기록 (보존 이유 : 정보통신망 이용촉진 및 정보보호 등에
      관한 법률, 보존 기간 : 6개월)
      <br />- 방문에 관한 기록 (보존 이유 : 통신비밀보호법, 보존 기간 : 3개월)
    </StyledP>
    <StyledH3>6. 개인정보 파기절차 및 방법</StyledH3>
    <StyledP>
      이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체
      없이 파기합니다. 서비스공급자의 개인정보 파기절차 및 방법은 다음과
      같습니다.
    </StyledP>
    <StyledH4>가. 파기절차</StyledH4>
    <StyledP>
      - 이용자가 서비스 가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의
      DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유
      및 이용기간 참조)일정 기간 저장된 후 파기됩니다.
      <br />- 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른
      목적으로 이용되지 않습니다.
    </StyledP>
    <StyledH4>나. 파기방법</StyledH4>
    <StyledP>
      - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
      <br />- 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
      방법을 사용하여 삭제합니다.
    </StyledP>
    <StyledH3>7. 이용자 및 법정대리인의 권리와 그 행사방법</StyledH3>
    <StyledP>
      이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만
      아동의 개인정보를 플랫폼사업자나 앱스토어사업자를 통해 조회하거나 수정할
      수 있으며 애플리케이션의 로그아웃과 삭제를 통해 서비스 해지를 요청할 수
      있습니다.
      <br />
      이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는
      플랫폼사업자나 앱스토어사업자를 통해 "계정 삭제"를 클릭하여 직접 열람,
      정정 또는 탈퇴가 가능합니다. 단, 서비스공급자가 보유하고 있지 않은
      개인정보를 확인하고자 할 경우 서비스공급자가 서비스 서비스를 제공하는
      플랫폼사업자나 앱스토어사업자의 가입 내역 확인 및 개인정보 제공을 통해
      서비스공급자에 기록된 정보와 대조하여 본인 확인을 할 수 있어야 합니다.
      <br />
      이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기
      전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를
      제3 자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이
      통지하여 정정이 이루어지도록 하겠습니다. 서비스공급자는 이용자 혹은 법정
      대리인의 요청에 의해 해지 또는 삭제된 개인정보는 ‘5. 개인정보의 보유 및
      이용기간’에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수
      없도록 처리하고 있습니다.
    </StyledP>
    <StyledH3>
      8. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
    </StyledH3>
    <StyledP>
      서비스공급자는 계정정보를 생성하기 위해 이용자가 서비스를 위한
      애플리케이션 실행 시, 기기식별번호 (단말기 아이디 또는 UDID, IMEI)를
      자동으로 수집할 수 있습니다. 또한 친구등록이나 친구추천 등의 기본기능을
      제공하기 위하여 플랫폼사용자로부터 고유식별번호와 친구목록과 관련된
      고유식별번호를 자동으로 수집할 수 있습니다.
      <br />
      이용자가 이 고유식별번호나 기기식별번호를 자동으로 수집하지 않으면
      정상적으로 친구 초대, 선물 등의 서비스 서비스를 제공할 수 없으므로 당사
      서비스를 정상적으로 이용할 수 없습니다.
    </StyledP>
    <StyledH3>9. 개인정보의 기술적/관리적 보호 대책</StyledH3>
    <StyledP>
      서비스공급자는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난,
      누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
      기술적/관리적 대책을 강구하고 있습니다.
    </StyledP>
    <StyledH4>가. 해킹 등에 대비한 대책 </StyledH4>
    <StyledP>
      서비스공급자는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가
      유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의
      훼손에 대비해서 자료를 수시로 백업하고, 이용자들의 개인정보나 자료가
      누출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여
      네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고
      침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타
      시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려
      노력하고 있습니다.
    </StyledP>
    <StyledH4>나. 취급 직원의 최소화 및 교육</StyledH4>
    <StyledP>
      서비스공급자의 개인정보관련 취급 직원은 담당자에 한정시키고 있고 이를 위한
      별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시
      교육을 통하여 Code States 개인정보취급방침의 준수를 항상 강조하고
      있습니다.
    </StyledP>
    <StyledH4>다. 개인정보보호전담기구의 운영</StyledH4>
    <StyledP>
      서비스공급자는 사내 개인정보보호전담기구 등을 통하여 Code States
      개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될
      경우, 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자
      본인의 부주의나 서비스공급자의 고의 또는 중대한 과실이 아닌 사유로
      개인정보가 유출되어 발생한 문제에 대해 서비스공급자는 일체의 책임을 지지
      않습니다.
    </StyledP>
    <StyledH3>10. 개인정보관리책임자 및 담당자의 연락처</StyledH3>
    <StyledP>
      귀하께서는 서비스공급자의 서비스를 이용하시며 발생하는 개인정보보호 관련
      민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.
      서비스공급자는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴
      것입니다.
    </StyledP>
    <StyledH4>담당 및 책임자 이름 : 김인기</StyledH4>
    <StyledH4>소속 및 직위 : Code States | CEO</StyledH4>
    <StyledH4>연락처 : 이메일 communication@codestates.com</StyledH4>
    <br />
    <StyledH4>
      기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에
      문의하시기 바랍니다.
    </StyledH4>
    <StyledP>
      - 개인정보침해신고센터 (http://www.118.or.kr | 118)
      <br />
      - 정보보호마크인증위원회 (http://www.eprivacy.or.kr | 02-580-0533~4)
      <br />
      - 대검찰청 첨단범죄수사과 (http://www.spo.go.kr | 02-3480-2000)
      <br />- 경찰청 사이버테러대응센터 (http://www.ctrc.go.kr | 02-392-0330)
    </StyledP>
    <StyledH3>11. 고지의 의무</StyledH3>
    <StyledP>
      현 개인정보취급방침의 내용 추가, 삭제 및 수정이 있을 시에는 시행일자 최소
      7일전부터 Code States 웹사이트나, 서비스 내 공지를 통해 공고할 것입니다.
      <br />
      <br />
      공고일 : 2015년 12월 1일
      <br />
      시행일 : 2015년 12월 1일
    </StyledP>
    <StyledH2>Code States 이용약관</StyledH2>
    <StyledH3>Code States 서비스 이용약관</StyledH3>
    <StyledH4>제정 : 2015년 12월 1일</StyledH4>
    <StyledH3>제 1조 (목적)</StyledH3>
    <StyledP>
      이 약관은 Code States (이하 "서비스제공자")가 제공하는 서비스 이용(이하
      "서비스")과 관련하여 서비스제공자와 이용자 간의 권리와 의무 및 필요한 제반
      사항을 정하는데 그 목적이 있습니다.
    </StyledP>
    <StyledH3>제2조 (용어의 정의)</StyledH3>
    <StyledP>
      ① 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
      <br />
      1. "이용자"란 서비스제공자가 제공하는 모든 제반 서비스를 이용하는 고객을
      의미합니다.
      <br />
      2. "서비스"란 서비스제공자가 제공하는 모든 서비스 일체를 의미합니다.
      <br />
      3. "단말기"란 서비스를 다운로드 받거나 설치하여 사용할 수 있는 PC, 휴대폰,
      스마트폰, PDA, 태블릿 등의 기기를 말합니다.
      <br />
      4. "애플리케이션"이란 서비스제공자가 제공하는 서비스를 이용하기 위하여
      ‘1항 3.’에서 설명한 단말기를 통해 다운로드 받거나 설치하여 사용하는
      프로그램 일체를 말합니다.
      <br />
      5. "앱스토어(오픈마켓)사업자"란 당사 앱을 설치하고 결제할 수 있도록
      제공하는 오픈마켓 등 전자상거래 제공자 일체(앱 내 결제를 제공하는 사업자
      포함)를 제공하는 사업자를 말합니다. (예. 구글 플레이 앱스토어, 애플
      앱스토어, 티스토어, 올레마켓, 유플러스 앱마켓 등)
      <br />
      6. "플랫폼사업자"란 당사 앱을 알리거나 이용함에 있어서 서비스제공자와
      제휴하여 서비스를 제공하는 사업자 및 관련 서비스 일체를 말합니다. (예.
      (주)카카오 의 카카오톡, (주)라인 의 라인, Facebook Inc. 의 페이스북 등)
      <br />
      7. "이용자 계정"이란 ‘1항의 6.’에서 설명한 플랫폼사업자가 제공하는
      본인식별을 위한 아이디, 메일주소 등의 정보로서 플랫폼사업자가 직접적으로
      명기 및 노출하여 제공받지 아니하고 고유식별번호(특별한 숫자 또는 문자로
      이루어짐)를 제공 받아 사용합니다. (예. TID, UID 등) 8. "유료콘텐츠"라
      함은, 이용자가 서비스를 이용함에 있어 특정한 효과 또는 효능을 향유하기
      위하여 ‘1항의 5.’에서 설명한 "앱스토어"를 통해 구매하는 온라인콘텐츠
      일체를 의미합니다. (예. 코인, 캐쉬 등)
      <br />
      9. "무료콘텐츠"라 함은, 이용자가 앱 내에서 ‘1항의 8.’에서 유료콘텐츠를
      통해 구매하지 아니한 이용자 간 선물이나 앱 서비스를 이용하면서 취득할 수
      있는 온라인 콘텐츠 일체를 의미합니다. (예. 포인트 등)
      <br />
      10. "In-App결제(In-App Purchase)"란 애플리케이션 내에서 아이템, 기능,
      유료콘텐츠 등을 구매하기 위한 결제 행위를 말합니다.
      <br />
      11. "In-App아이템"이란 In-App결제를 통하여 이용자가 구매할 수 있는 아이템,
      기능 등을 말합니다.
      <br />
      <br />② 이 약관에서 사용하는 용어의 정의는 1항에서 정하는 것을 제외하고는
      관계법령에서 정하는 바에 의합니다. 관계법령에서 정하지 않는 것은 일반적인
      상관례에 의합니다.
    </StyledP>
    <StyledH3>제3조 (약관의 효력과 변경)</StyledH3>
    <StyledP>
      ① 이 약관은 서비스 이용계약의 성격상 서비스제공자의 웹사이트 또는 서비스
      이용을 위한 애플리케이션 내에 이 약관을 명시하고, 이용자가 어플리케이션을
      설치 및 실행함과 동시에 효력이 발생하게 됩니다.
      <br />
      ② 서비스제공자는 관련 법령의 변경이나 이용자의 권리 및 의무사항을 개선하기
      위해 이 약관을 변경할 수 있으며, 변경된 약관은 변경된 약관 적용일 전
      7일간(다만, 이용자의 권리∙의무에 중대한 영향을 미치는 사항에 대하여는
      30일간) 서비스제공자 홈페이지나 공식 카페, 제공하는 애플리케이션 등을 통해
      이용자에게 고지하고 적용일부터 효력이 발생됩니다.
      <br />③ 이용자는 변경된 약관에 대해 동의하지 않을 권리가 있으며, 변경된
      약관에 동의하지 않을 경우에는 어플리케이션 로그아웃 및 삭제와 함께 서비스
      이용을 중단하고 탈퇴할 수 있습니다. 다만, 이용자가 ‘제2항의 방법’ 등으로
      별도 고지한 바에 따라 변경된 약관의 적용일로부터 15일 이내에
      서비스제공자에 대해 "거부"의 의사표시를 하지 아니하는 경우에는 변경된
      약관에 동의한 것으로 간주합니다.
    </StyledP>
    <StyledH3>제4조 (이용 계약의 성립)</StyledH3>
    <StyledP>
      ① 이용계약은 "이용자"의 애플리케이션 설치 등의 이용신청 및 약관 동의와, 그
      이용신청에 대한 서비스제공자의 이용승낙으로 성립합니다.
      <br />② 이 약관에 대한 동의는 서비스 이용을 위한 애플리케이션 설치 및
      이용신청 당시, 서비스제공자의 홈페이지에 고시된 이용약관 확인 또는
      애플리케이션 내에서 개인정보의 수집 및 이용에 동의함으로써 이 약관에
      동의하는 의사표시가 되며, 애플리케이션 구동과 동시에 계약은 성립됩니다.
      만약 개정 및 시행일 이전에 해당 동의 절차 없이 실행한 경우에도 이 약관에
      동의한 것으로 간주되며, 동의하지 않을 경우 애플리케이션 로그아웃 및 삭제와
      함께 이용자는 이를 철회할 수 있습니다.
    </StyledP>
    <StyledH3>제5조 (서비스제공자의 의무)</StyledH3>
    <StyledP>
      ① 서비스제공자는 이용자로부터 제기되는 의견이나 불만이 정당하다고
      객관적으로 인정될 경우에는 합리적인 기간 내에 신속하게 처리하여야 합니다.
      다만, 처리에 장기간이 소요되는 경우에는 이용자에게 그 사유와 처리일정을
      서비스 홈페이지에 공지하여야 합니다.
      <br />
      ② 서비스제공자는 이용자의 계정정보를 포함한 일체의 개인정보가
      서비스제공자가 관리하는 서비스 시스템으로부터 유출되지 않도록 하며,
      제3자에게 공개 또는 제공되지 아니하도록 보호합니다.
      <br />
      ③ 서비스제공자는 계속적이고 안정적인 서비스의 제공을 위하여 서비스 개선을
      하던 중 설비에 장애가 생기거나 데이터 등이 멸실된 때에는 천재지변,
      비상사태, 해결이 곤란한 기술적 결함 등 부득이한 사유가 없는 한 지체 없이
      이를 수리 또는 복구하도록 최선의 노력을 다합니다. ④ 서비스제공자는
      이용계약의 체결, 계약사항의 변경 및 해지 등 이용자와의 계약관련 절차 및
      내용 등에 있어 이용자에게 편의를 제공하도록 노력합니다.
      <br />⑤ 서비스제공자는 개인정보 보호를 위해 개인정보취급방침 공시하고
      준수합니다.
    </StyledP>
    <StyledH3>제6조 (이용자의 의무)</StyledH3>
    <StyledP>
      ① 이용자는 서비스제공자에서 제공하는 서비스를 서비스 본래의 이용목적
      이외의 용도로 사용하거나 다음 각 호에 해당하는 행위를 해서는 안됩니다.
      <br />
      1. 고객 문의, 유료 콘텐츠 복구 및 환불요청, 이벤트 당첨 등으로 인해
      서비스제공자에 개인정보 제공 시 실명이 아닌 정보 또는 다른 사람의 정보를
      사용하거나, 허위 사실을 기재하는 행위
      <br />
      2. 타인으로 가장하거나 타인과의 관계를 허위로 명시하는 행위, 다른 이용자의
      ID 및 비밀 번호를 도용, 부정하게 사용하거나, 타인의 신용카드, 유/무선전화,
      은행 계좌 등을 무단으로 도용하여 유료콘텐츠를 구매하는 행위
      <br />
      3. 서비스제공자가 제공하지 않는 서비스를 통해 유료콘텐츠 등을 타인과
      거래하거나 매매하는 행위
      <br />
      4. 서비스제공자의 서비스 및 제공된 애플리케이션을 이용하여 얻은 정보를
      서비스제공자의 사전 승낙 없이 복제, 유통, 조장하거나 상업적으로 이용, 또한
      알려지거나 알려지지 않은 버그를 악용하여 서비스를 이용하는 행위.
      <br />
      5. 서비스제공자의 서비스 및 제공된 애플리케이션을 이용하여 자기 또는
      타인에게 재산상의 이익을 발생시키는 행위
      <br />
      6. 타인의 명예를 훼손하거나 손해를 가하는 행위
      <br />
      7. 서비스제공자의 지적재산권, 제3자의 지적재산권, 초상권 등 기타 권리를
      침해하거나 서비스제공자의 승인을 받지 않고 다른 이용자의 개인정보를 수집,
      저장, 유포, 게시하는 행위
      <br />
      8. 제3자를 기망하여 이득을 취하거나 서비스제공자가 제공하는 서비스를
      불건전하게 이용하거나 하여, 제3자에게 피해를 주는 행위
      <br />
      9. 음란, 저속한 정보를 교류, 게재하거나 음란사이트를 연결(링크)하거나
      승인되지 않은 광고 및 홍보물 게재하는 행위
      <br />
      10. 재물을 걸고 도박하는 등 사행 행위를 유도하거나 참여하는 행위
      <br />
      11. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는
      영상을 상대방에게 전송, 도달, 유포하는 행위
      <br />
      12. 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터프로그램)
      또는 컴퓨터소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해,
      파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일,
      프로그램을 포함하고 있는 자료를 전송, 게시, 유포, 사용하는 행위
      <br />
      13. 서비스제공자로부터 특별한 권리를 부여 받지 않고 애플리케이션을
      변경하거나 애플리케이션에 다른 프로그램을 추가 또는 삽입하거나 서버를
      해킹, 역설계하거나, 소스코드나 애플리케이션 데이터의 유출 및 변경, 별도의
      서버를 구축하거나 웹사이트의 일부분을 임의로 변경 또는 도용하여
      서비스제공자를 사칭하는 행위
      <br />
      14. 서비스제공자의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의
      명의를 도용하여 글을 게시하거나 메일을 발송하는 행위
      <br />
      15. 기타 공공질서 및 미풍양속을 위반하거나 불법적, 부당한 행위 및
      관계법령에 위배되는 행위
      <br />
      <br />② 이용자는 서비스제공자 홈페이지 상의 공지 사항 및 이용약관의
      수정사항을 수시로 확인하여야 합니다.
    </StyledP>
    <StyledH3>제7조 (서비스의 제공 시간 및 중지)</StyledH3>
    <StyledP>
      서비스제공자는 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일
      24시간 서비스 제공을 원칙으로 합니다. 다만, 시스템 정기점검, 서버의 증설
      및 교체, 새로운 앱 내용의 추가, 각종 버그 패치, 새로운 서비스로의 교체 등
      운영상 필요한 경우, 일정기간 동안 서비스를 일시 중지시킬 수 있으며, 이러한
      경우 서비스제공자는 그 내용 및 시간을 홈페이지나 애플리케이션 내에
      공지합니다. 다만, 서비스제공자가 사전에 통지할 수 없는 부득이한 사유가
      있는 경우 사후에 통지할 수 있습니다.
      <br />
    </StyledP>
    <StyledH3>제8조 (서비스 내용 및 변경)</StyledH3>
    <StyledP>
      ① 서비스제공자는 새로운 앱 내용, 각종 버그 패치 등 서비스의 운영상 또는
      기술상의 필요한 경우, 제공하고 있는 서비스의 전부 또는 일부를 상시적으로
      수정, 추가, 폐지 등 변경할 수 있습니다. 변경될 서비스의 내용 및 제공일자
      등에 대해서는 운영하는 홈페이지에 게시하여 통지합니다.
      <br />
      ② 서비스제공자는 서비스의 기획이나 운영상 또는 서비스제공자의 긴박한 상황
      등에 의해 서비스 전부를 중단할 필요가 있는 경우 홈페이지에 이를 공지하고
      서비스의 제공을 중단할 수 있습니다. 이용자는 서비스 종료 시 사용 기간이
      남아 있지 않은 유료 콘텐츠에 대하여 환불을 요청할 수 없습니다.
      <br />
      ③ 서비스제공자는 다음 각호에 해당하는 경우 서비스의 전부 또는 일부를
      제한하거나 중지할 수 있습니다.
      <br />
      1. 전시, 사변, 천재지변 또는 국가비상사태 등 불가항력적인 사유가 있는 경우
      <br />
      2. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에
      지장이 있는 경우
      <br />
      3. 서비스용 설비의 보수 등 공사로 인한 부득이한 경우
      <br />
      4. 서비스제공자의 제반 사정으로 서비스를 할 수 없는 경우
      <br />
      ④ ‘제3항’에 의한 서비스 중단의 경우에는 서비스제공자가 운영하는 홈페이지나
      애플리케이션 내에 게시하여 통지합니다. 다만, 서비스제공자가 통제할 수 없는
      사유로 인한 서비스의 중단으로 인하여 사전 통지가 불가능한 경우에는
      그러하지 아니합니다.
      <br />⑤ 서비스제공자는 서비스가 변경되거나 중지된 원인이 서비스제공자의
      고의 또는 중과실로 인한 경우를 제외하고는 서비스의 변경 및 중지로 발생하는
      문제에 대해서 책임을 지지 않습니다.
    </StyledP>
    <StyledH3>제9조 (정보의 제공 및 게재)</StyledH3>
    <StyledP>
      ① 서비스제공자는 이용자 대상 서비스에 대한 소개, 서비스 개선 등을 위한
      목적으로 플랫폼사업자 및 앱스토어사업자를 통해 취득한 정보를 사용하거나
      이용자 개인에 대한 추가정보를 요구할 수 있으며, 동 요청에 대해 이용자는
      플랫폼사업자나 앱스토어사업자를 통해 해당 서비스에서 승낙하여 추가정보를
      제공하거나 거부할 수 있습니다.
      <br />
      ② 서비스제공자는 본 서비스 등을 유지하기 위하여 광고를 게재할 수 있으며,
      이용자는 서비스 이용 시 노출되는 광고게재에 대하여 동의합니다.
      <br />
      ③ 서비스제공자가 제공하는, 제3자가 주체인, ‘제2항’의 광고에 이용자가
      참여하거나 교신 또는 거래를 함으로써 발생하는 손실과 손해에 대해서
      서비스제공자는 어떠한 책임도 부담하지 않습니다. ④ 서비스제공자는 이용자의
      사전 동의 하에 이용자로부터 수집한 개인정보를 활용하여 ‘제1항’의 정보제공
      및 ‘제2항’의 광고 등을 제공하는 경우 SMS(LMS), 스마트폰 알림(Push 알림),
      메일주소 등을 활용하여 발송할 수 있으며, 이용자가 원하지 않는 경우에는
      언제든지 수신을 거부할 수 있습니다.
      <br />⑤ 상기 정보제공과 광고와 관련해서는 정보를 서비스제공자에 제공하는
      플랫폼사업자, 앱스토어사업자의 약관 및 서비스제공자의 약관에 준거하며 관련
      법령 및 시행령에 따라 제공합니다.
    </StyledP>
    <StyledH3>제10조 (유료 컨텐츠의 구매, 사용기간 및 이용)</StyledH3>
    <StyledP>
      ① 이용자는 서비스를 사용하고 있는 단말기의 종류에 따른 각 앱스토어사업자의
      결제 운영정책에 따라 유료콘텐츠를 구매할 수 있으며, 해당 결제 정책의
      차이로 인해 결제금액의 차이가 발생할 수 있습니다. 또한 유료콘텐츠의 구매
      대금은 앱스토어사업자와 연계된 이동통신사나 플랫폼사업자 및
      앱스토어사업자가 정하는 방법 및 정책에 따라 부과되며, 납부방식 역시 해당
      사업자의 정책을 따릅니다.
      <br />
      ② 앱 서비스 내에서 이용자가 구매한 유료 콘텐츠는 해당 앱 서비스
      애플리케이션을 다운로드 받거나 설치한 단말기에서만 이용할 수 있습니다.
      <br />③ 이용자가 구매한 유료콘텐츠의 사용기간은 기본적으로 1년이며 이
      기간이 경과한 후에는 이용자는 해당 유료콘텐츠에 대한 사용권을 상실합니다.
      단, 사용기간이 별도로 명시된 유료콘텐츠의 경우는 구매 시 명시된 사용
      기간에 따릅니다. 이용자는 서비스제공자가 정하여 별도로 고지한 방법
      이외에는 유료 컨텐츠를 이용자 본인의 계정에서만 이용할 수 있으며, 제
      3자에게 양도, 대여, 매매할 수 없습니다.
    </StyledP>
    <StyledH3>제11조 (In-App 결제)</StyledH3>
    <StyledP>
      ① 서비스제공자의 애플리케이션은 In-App아이템 구매를 위한 In-App결제 기능을
      포함하고 있습니다.
      <br />
      ② 이용자는 단말기의 비밀번호 설정 기능, 오픈마켓에서 제공하는 비밀번호
      설정 기능 등을 이용하여 제3자의 In-App결제를 방지하여야 하며,
      서비스제공자는 이를 위하여 방송통신위원회의 권고 및 ‘오픈마켓 모바일콘텐츠
      결제 가이드라인’에 따라 오픈마켓이 제공하는 인증절차 등이 적용된
      In-App결제를 위한 모듈, 라이브러리 등을 애플리케이션에 적용합니다.
      <br />
      ③ 이용자가 단말기 및 오픈마켓의 비밀번호 설정 기능 등을 이용하지 않거나
      부주의하게 노출하여 발생하는 제3자의 In-App결제에 대하여는 서비스제공자가
      어떠한 책임도 부담하지 않습니다.
      <br />
      ④ 이용자가 이동통신사의 청소년 요금제에 가입한 경우, 해당 단말기에서의
      In-App결제를 하면 그 내용은 법정대리인의 동의가 있는 것으로 간주합니다.
      <br />⑤ 이용자는 In-App결제 대금을 성실히 납부하여야 할 책임이 있습니다.
    </StyledP>
    <StyledH3>제12조 (청약 철회 및 환불 등)</StyledH3>
    <StyledP>
      ① 이용자가 구매한 유료콘텐츠의 경우에는 계약 체결일 또는 유료콘텐츠
      이용가능일로부터 7일 이내에 별도의 수수료 없이 청약철회(구매취소)를 할 수
      있습니다. 단, 선물 및 이벤트 등 서비스제공자나 제3자로부터 무상으로
      제공받은 유료콘텐츠, 청약철회 요청 당시 이미 사용하였거나 사용한 것으로
      간주되는 유료콘텐츠 등 이에 준하는 특성을 가진 일부 유료콘텐츠에 대하여는
      전자상거래 등에서의 소비자보호에 관한 법률 제17조 제2항 제2호 내지 제3호
      및 온라인 디지털콘텐츠산업 발전법 제16조의2에 따라 청약철회(구매취소)가
      제한될 수 있습니다. 이 경우 서비스제공자는 이용자가 해당 유료콘텐츠 구매
      시 고지하는 등 관련 법률에서 정한 바에 따른 조치를 취하기로 합니다.
      <br />
      ② 서비스제공자의 귀책사유로 인하여 구매한 유료 컨텐츠를 이용하지 못하는
      경우, 동일한 유료 컨텐츠를 무상으로 제공하거나 해당 구매 금액을
      계약체결일(구매일)에 관계없이 전액 환불합니다. ③ 환불은 서비스를 사용하고
      있는 단말기의 운영체제 종류에 따라 각 앱스토어사업자의 환불 운영정책에
      따라 진행되며, 자세한 환불 신청 절차는 서비스제공자 홈페이지 상에 공지된
      바에 따릅니다. 또한 환불이 된 대가에 따라 앱 내 유료콘텐츠는 해당 철회된
      금액만큼 차감하여 반영합니다.
      <br />
      ④ 유료콘텐츠를 통해 무료콘텐츠로 전환한 경우에는 이용자가 사용 의사를 밝힌
      것으로 판단할 수 있으며, 또한 전체 혹은 일부 사용으로 인하여 앱 서비스
      내에서 구매할 수 있는 기본 단위가 훼손되었을 시에도 서비스제공자는
      이용자가 사용 의사를 밝힌 것으로 판단합니다. 또한 메시지함 및 선물함 등
      유료콘텐츠의 송수신과 관련된 화면에서 수락 등의 동의 과정을 거친 경우 이는
      이용자가 사용 의사를 밝힌 것으로 판단합니다. 해당 사항은 고객의 의도와
      상이하게 타인을 통해 구매되었을 경우도 포함합니다.
      <br />
      ⑤ 이용자가 실제 정상적인 구매내역이 기록되는 이용대금의 결제를 통하지 않고
      앱 서비스 중에 보상으로 취득하거나, 서비스제공자가 내부 이벤트 혹은 외부
      제휴 이벤트 등을 통하여 지급한 유료 콘텐츠는 환불하지 않습니다.
      <br />
      ⑥ 청약철회 및 환불 등을 요구할 경우에는 서비스제공자 고객센터 및
      서비스제공자가 지정한 위탁업체에 별도의 개인정보 취급에 대한 동의 과정을
      거친 후 서비스제공자의 구매내역 확인에 의해 진행되며, 이 과정 중
      플랫폼사업자 또는 앱스토어사업자를 통해 구매내역을 확인하는 절차를 거친
      다음 진행됩니다. 서비스제공자는 이 과정 중에서 이용자의 정당한 철회 사유를
      확인하기 위해 이용자에게서 제공받은 정보를 통해 이용자에게 연락하여 정확한
      사실 확인을 할 수 있으며, 추가적으로 증빙을 요구할 수 있습니다. (예.
      플랫폼사업자에 등록된 개인정보, 앱스토어의 구매 또는 결제내역, 고객의
      의도와 상이하게 타인을 통해 구매되었다는 것을 확인할 수 있는 서류(가족관계
      증명) 등)
      <br />
      ⑦ 다음과 같은 경우 In-App아이템의 청약철회가 제한되며 서비스제공자는
      청약철회가 제한되는 In-App아이템에 대해서 In-App결제 전에 청약철회가
      제한됨을 표시합니다.
      <br />
      1. 구매 후 즉시 사용이 시작되거나 즉시 애플리케이션에 적용되는
      In-App아이템의 경우
      <br />
      2. 애플리케이션의 정상적인 이용과정에서 In-App결제 없이 획득한
      In-App아이템의 경우
      <br />
      3. 추가적인 혜택이 제공되는 In-App아이템에서 해당 추가 혜택이 사용된 경우
      <br />
      4. 묶음형으로 판매된 In-App아이템의 일부가 사용된 경우
      <br />
      5. 개봉행위를 사용으로 볼 수 있거나 개봉 시 효용이 결정되는 캡슐형/확률형
      In-App아이템의 경우
      <br />
      ⑧ 애플리케이션에서 판매되는 In-App아이템을 미성년자가 법정대리인의 동의
      없이 In-App 결제한 경우, 미성년자 또는 법정대리인은 In-App결제를 취소할 수
      있습니다. 단, 미성년자의 In-App결제가 법정대리인으로부터 처분을 허락 받은
      재산의 범위 내인 경우 또는 미성년자가 사술 등을 사용하여 성년자로 믿게 한
      때에는 취소가 제한됩니다. In-App아이템 구매자가 미성년자인지 여부는
      In-App결제가 진행된 단말기 또는 신용카드 등 결제수단의 명의자를 기준으로
      판단됩니다. 미성년자 결제취소를 요청하시는 경우 서비스제공자의 필요에 따라
      미성년자 및 법정대리인을 증명할 수 있는 서류를 제출하여야 합니다.
      <br />
      ⑨ 애플리케이션의 In-App결제는 오픈마켓사업자가 제공하는 결제방식에
      따릅니다. 따라서 In-App결제 과정에서 과오금이 발생하는 경우 원칙적으로
      오픈마켓사업자에게 환급을 요청하여야 합니다. 단, 오픈마켓사업자의 정책,
      시스템에 따라 가능한 경우 서비스제공자가 오픈마켓사업자에게 필요한
      환급절차의 이행을 요청할 수도 있습니다.
      <br />⑩ 선물하기 기능을 통하여 이루어진 In-App결제에 대하여는 구매한
      In-App아이템에 하자가 있는 경우를 제외하고는 원칙적으로 결제 취소 및
      환급이 불가하며, In-App아이템의 하자로 인한 환급은 선물을 보낸 이용자에
      한하여 가능합니다.
    </StyledP>
    <StyledH3>제13조 (계약 해지 및 서비스 이용 중지 등)</StyledH3>
    <StyledP>
      ① 이용자가 다음 각 호의 사유에 해당하는 행위를 한 경우, 서비스제공자는
      사전통보 없이 이용계약을 해지하거나 또는 기간을 정하여 서비스 이용을 중지
      할 수 있습니다.
      <br />
      1. 서비스 신청 시에 허위 내용을 등록하거나 타인의 서비스 아이디 및
      비밀번호, 결제 정보 등을 도용한 경우
      <br />
      2. 서비스 운영을 고의로 방해하거나 한 경우 또는 안정적 운영을 방해할
      목적으로 다량의 정보를 전송하거나 광고성 정보를 전송하는 경우
      <br />
      3. 정보통신설비의 오작동이나 정보 등의 파괴를 유발시키는 컴퓨터 바이러스
      프로그램 등을 유포하는 경우
      <br />
      4. 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우
      <br />
      5. 서비스제공자 및 다른 회원 또는 타인의 지적재산권을 침해하는 경우
      <br />
      6. 정보통신윤리위원회 등 회부기관의 시정요구가 있거나 불법선거 운동과
      관련하여 선거관리위원회의 유권해석을 받은 경우
      <br />
      7. 서비스제공자의 서비스 정보를 이용하여 얻은 정보를 서비스제공자의 사전
      승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우 또는
      서비스제공자의 서비스를 사칭하여 메시지 등을 발송한 경우
      <br />
      8. 음란물을 게재하거나 음란사이트를 링크하는 경우
      <br />
      9. 기타 제6조 이용자의 주요한 의무 항목을 위배하여 서비스제공자의 서비스에
      지장을 초래한 경우
      <br />② 전항의 규정에 따라 서비스제공자가 이용계약을 해지하거나 중단하는
      경우 이용자는 서비스 로그아웃 및 다운로드 받은 애플리케이션을 삭제하여야
      합니다.
    </StyledP>
    <StyledH3>제14조 (손해배상)</StyledH3>
    <StyledP>
      ① 이용자가 이 약관의 의무를 위반함으로 인하여 서비스제공자에 손해를 입힌
      경우, 또는 이용자가 서비스를 이용함에 있어 서비스제공자에 손해를 입힌
      경우에 이용자는 서비스제공자에 대하여 그 손해를 배상하여야 합니다.
      <br />② 이용자가 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로
      인하여 서비스제공자가 당해 이용자 이외의 제3자로부터 손해배상 청구 또는
      소송을 비롯한 각종 이의제기를 받는 경우, 당해 이용자는 자신의 책임과
      비용으로 서비스제공자를 면책시켜야 하며, 서비스제공자가 면책되지 못한
      경우, 당해 이용자는 그로 인하여 서비스제공자에 발생한 모든 손해를 배상할
      책임이 있습니다.
    </StyledP>
    <StyledH3>제 15조 (면책)</StyledH3>
    <StyledP>
      ① 서비스제공자는 전시, 사변, 천재지변, 국가비상사태, 해결이 곤란한 기술적
      결함 기타 불가항력적 사유로 서비스를 제공할 수 없는 경우에는 책임이
      면제됩니다.
      <br />
      ② 서비스제공자는 이용자의 귀책사유로 인한 서비스의 중지/이용장애에 대하여
      책임을 지지 아니하며, 서비스제공자는 기간 통신 사업자가 전기통신서비스를
      중지하거나 정상적으로 제공하지 아니하여 이용자에게 손해가 발생한 경우에는
      책임이 면제됩니다.
      <br />
      ③ 서비스제공자는 사전에 공지되거나 긴급하게 실시된 서비스용 설비의 보수,
      교체, 정기점검, 공사 등 부득이한 사유로 서비스가 중지되거나 장애가 발생한
      경우에 대해서는 책임이 면제됩니다. ④ 서비스제공자는 이용자가 서비스를
      이용하여 기대하는 점수, 순위 등을 얻지 못한 것에 대하여 책임을 지지 않으며
      서비스에 대한 취사 선택 또는 이용으로 발생하는 손해 등에 대해서는 책임이
      면제됩니다.
      <br />
      ⑤ 서비스제공자는 이용자가 본인의 개인정보 등(계정 포함)을 변경하여 얻는
      불이익 및 정보상실에 대해서는 일체 책임을 지지 않습니다.
      <br />
      ⑥ 서비스제공자는 이용자의 단말기 환경으로 인하여 발생하는 제반 문제 또는
      서비스제공자의 귀책사유가 없는 네트워크 환경으로 인하여 발생하는 문제에
      대해서 책임을 지지 않습니다.
      <br />
      ⑦ 서비스제공자는 이용자 상호간 또는 이용자와 제3자 간에 서비스를 매개로
      발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도
      없습니다.
      <br />⑧ 서비스제공자가 제공하는 서비스 중 무료 서비스 및 콘텐츠의 경우에는
      손해 배상의 대상에서 제외됩니다. 다만, 서비스제공자의 고의 또는 중대한
      과실로 인하여 발생한 손해의 경우는 제외합니다.
    </StyledP>
    <StyledH3>제16조 (재판권 및 준거법)</StyledH3>
    <StyledP>
      ① 서비스 이용과 관련하여 서비스제공자와 이용자간에 발생한 분쟁에 관한
      소송은 민사소송법 등 관련법률상의 관할법원에 제기합니다.
      <br />② 서비스제공자와 이용자간에 제기된 소송에는 대한민국 법을
      적용합니다.
    </StyledP>
    <StyledH3>제17조 (공간 이동)</StyledH3>
    <StyledP>
      ① 서비스 이용과 관련하여 서비스 제공 공간은 변경될 수 있습니다.
      <br />② 이용자는 서비스 제공 공간의 변경이 가능함을 충분히 인지하고
      동의합니다.
    </StyledP>
    <StyledH3>부칙 (2015. 12. 1)</StyledH3>
    <StyledP>이 약관은 2015년 12월 1일부터 시행합니다.</StyledP>
  </Wrapper>
)

export default PrivateTermsAndConditions
